import React from 'react';
import { Share2, Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { useT } from '../services/i18n';
import { withUtm, trackShare } from '../services/shareTracking';

export const compareShareUrl = (products) => `${window.location.origin}/comparaison?ids=${products.map(p => p.id).join(',')}`;

// WhatsApp + copy-link sharing of a side-by-side comparison (to ask a mechanic's opinion) — counted (GA4 `share` + admin stats), link tagged utm_source=share
const ShareCompareButtons = ({ products, testId = 'compare-share', size = 'sm' }) => {
  const { t, lang } = useT();
  if (!products?.length) return null;
  const url = compareShareUrl(products);
  const ids = products.map(p => p.id);
  const text = t('equiv.shareText', { names: products.map(p => `${p.brand} ${p.ref}`).join(' / ') });
  const track = (method) => trackShare(method, 'compare', { itemId: ids.join(','), path: `/comparaison?ids=${ids.join(',')}`, lang, product_ids: ids, gaParams: { items_count: ids.length } });
  const copy = async () => {
    const u = withUtm(url, 'copy_link', 'compare');
    try { await navigator.clipboard.writeText(u); toast.success(t('equiv.shareCopied')); } catch { window.prompt(t('equiv.shareCopy'), u); }
    track('copy_link');
  };
  return (
    <div className="inline-flex items-center gap-1.5" data-testid={testId}>
      <a href={`https://wa.me/?text=${encodeURIComponent(`${text}\n${withUtm(url, 'whatsapp', 'compare')}`)}`} onClick={() => track('whatsapp')} target="_blank" rel="noreferrer" data-testid={`${testId}-whatsapp`}
        className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5d] transition-colors">
        <Share2 size={13} /> {t('equiv.shareWhatsapp')}
      </a>
      <Button type="button" variant="outline" size={size} onClick={copy} data-testid={`${testId}-copy`} className="h-8 rounded-full text-xs"><Link2 size={13} className="mr-1" /> {t('equiv.shareCopy')}</Button>
    </div>
  );
};

export default ShareCompareButtons;
